import { Box, Typography, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const WorkQueueHeader = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 2,
			}}
		>
			<Typography sx={{ fontSize: '17px', fontWeight: 700 }}>
				Work Queue
			</Typography>

			<TextField
				size='small'
				disabled
				placeholder='Search Work Queue Items…'
				inputProps={{
					'aria-label': 'Search Work Queue Items',
				}}
				InputProps={{
					startAdornment: (
						<InputAdornment position='start'>
							<SearchIcon sx={{ fontSize: 16 }} />
						</InputAdornment>
					),
				}}
				sx={{
					width: '240px',
					'& .MuiOutlinedInput-root': {
						height: '30px',
						fontSize: '11px',
						backgroundColor: 'background.paper',
					},
				}}
			/>
		</Box>
	);
};

export default WorkQueueHeader;
